import { useNavigate } from "react-router-dom";
import { ReactComponent as AcedImg } from "../../assets/images/AcedWhite.svg";
import { ReactComponent as Close } from "../../assets/images/Close.svg";
import Button from "../../components/essentials/button/Button";
import "./PaymentResult.scss";

const PaymentFailed: React.FC = () => {
	const navigate = useNavigate();

	return (
		<div className="payment-result">
			<AcedImg />
			<div className="payment-result__captions">
				<div className="payment-result__icon-error">
					<Close className="payment-result__icon" />
				</div>
				<p className="payment-result__captions-title">Payment Failed</p>
				<p className="payment-result__captions-subtitle">
					We couldn't process your payment. Please try again or contact support.
				</p>
			</div>

			<div className="payment-result__buttons">
				<Button
					className="btn btn-primary--white-bg"
					action={() => navigate("/subscription")}
				>
					Try Again
				</Button>
				<Button
					className="btn btn-link"
					action={() => navigate("/board")}
				>
					Go to Dashboard
				</Button>
			</div>
		</div>
	);
};

export default PaymentFailed;
